import { ArrowRight } from '@peacecover/icon';
import GradientCardFillIcon from '../icons/GradientCardFillIcon';
import { Link } from 'react-router-dom';
import { t } from 'i18next';

const ExcludePhotoCardSection = () => {
  const artist = localStorage.getItem('artist');

  return (
    <Link
      to={`/artists/${artist}/blacklist_trading_photo_cards`}
      className="h-[68px] flex flex-row items-center justify-between px-[17px] py-[5px] gap-[10px] shadow-[0_0_10.2px_0_rgba(0,0,0,0.04)] dark:shadow-[0_0px_3px_0px_rgba(0,0,0,0.35),_0px_0px_10.2px_0px_rgba(0,0,0,0.32)] border-[1px] border-separator1 dark:border-separator2 dark:bg-background-elevated rounded-[12px] mt-[14px] mx-[24px]"
    >
      <div className="w-[40px] h-[40px] rounded-full bg-surface-lv2 flex items-center justify-center">
        <GradientCardFillIcon size={24} />
      </div>
      <div className="flex flex-col gap-[4px] leading-none">
        <p className="h-[17px] font-semibold text-[14px] text-text-main-lv2 ">
          {t('NewTradingPhotoCards.excludePhotoCardSectionTitle')}
        </p>
        <p className="h-[16px] text-[13px] text-text-main-lv4">
          {t('NewTradingPhotoCards.excludePhotoCardSectionDescription')}
        </p>
      </div>
      <ArrowRight size={16} className="text-text-main-lv4" />
    </Link>
  );
};

export default ExcludePhotoCardSection;
